import { motion } from 'framer-motion';
import './SuggestionMessage.css';

export default function SuggestionMessage({ text, index }) {
  return (
    <motion.div
      className="suggestion-message"
      layout="position"
      initial={{ x: "-150%" }}
      animate={{ x: 0 }}
      exit={{ x: "-150%" }}
      transition={{
        duration: 0.4,
        delay: 0.2 + index * 0.1,
        ease: "easeOut"
      }}

    >
      {text}
    </motion.div>
  );
}

